/* eslint arrow-body-style: */
import { DISABLE_NOTIFICATION, SHOW_NOTIFICATION } from './constants';

const disableNotification = () => ({
	type: DISABLE_NOTIFICATION,
});

/**
 * Display a snack bar notification
 * @param {SnackBarSettings} settings
 * @param {Array of func} optional array of callbacks which can be used
 * for cleanup or whatever.
 */
const showNotification = (settings, callbacks = []) => {
	return dispatch => {
		dispatch({
			type: SHOW_NOTIFICATION,
			settings,
		});

		if (Array.isArray(callbacks)) {
			callbacks.forEach(callback => {
				dispatch(callback);
			});
		}
	};
};

export {
	disableNotification,
	showNotification,
};
